"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.controlToControlLink = exports.riskToRiskLink = exports.controlToSuggestion = exports.riskToSuggestion = exports.causalityToSuggestion = void 0;
var urls_1 = require("../urls");
function causalityToSuggestion(causality) {
    var prefix = causality.is_cause ? get_term("Cause") : get_term("Effect");
    return {
        value: causality.id.toString(),
        label: causality.text,
        suggestionLabel: "".concat(prefix, " #").concat(causality.number, " ").concat(causality.text),
    };
}
exports.causalityToSuggestion = causalityToSuggestion;
function riskToSuggestion(risk) {
    return {
        value: risk.id.toString(),
        label: risk.title,
        suggestionLabel: "#".concat(risk.risk_number, " ").concat(risk.title),
    };
}
exports.riskToSuggestion = riskToSuggestion;
function controlToSuggestion(control) {
    return {
        value: control.id.toString(),
        label: control.description,
        suggestionLabel: "#".concat(control.control_number, " ").concat(control.description),
    };
}
exports.controlToSuggestion = controlToSuggestion;
function riskToRiskLink(risk) {
    var url = (0, urls_1.resolve)(urls_1.Urls.risk_detail, risk.project, risk.id);
    return {
        id: risk.id,
        number: risk.risk_number,
        title: risk.title,
        url: url,
    };
}
exports.riskToRiskLink = riskToRiskLink;
function controlToControlLink(control) {
    var url = (0, urls_1.resolve)(urls_1.Urls.control_detail, control.project, control.id);
    return {
        id: control.id,
        number: control.control_number,
        title: control.description,
        url: url,
    };
}
exports.controlToControlLink = controlToControlLink;
